import { useMemo } from "react"

import { ReportingBarChart } from "@/components/reporting/charts"
import { api } from "@/lib/api"

export function ConversationsChart() {
	const query = api.analytics.conversationsChart.useQuery({})

	const chartData = useMemo(
		() =>
			(query.data?.chartData ?? []).map((point) => ({
				date: point.date,
				aiChat: point.aiChat,
				other: point.other,
			})),
		[query.data?.chartData],
	)

	return (
		<ReportingBarChart
			title="Conversations"
			description="Productlane Agent conversations vs all other origins, by week."
			data={chartData}
			series={[
				{ key: "other", label: "Other", tone: "secondary" },
				{ key: "aiChat", label: "Productlane Agent", tone: "primary" },
			]}
			stacked
			isLoading={query.isLoading}
			height={220}
		/>
	)
}
